import * as React from 'react';

import { useRef, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import BackgroundImage from '@src/components/background-image';
import Store from './store';
import { start } from '@src/utils/x-ani';
import { X_ANI_CONFIG } from './animation';
const styles = require('./index.less');

export default wrapStore(({ store, isActive }) => {
  store.use();
  const ctxRef = useRef(null);

  useEffect(
    () => {
      if (!ctxRef.current) {
        ctxRef.current = start(X_ANI_CONFIG, '#featureSection');
      } else {
        if (isActive) {
          ctxRef.current.restart();
        } else {
          ctxRef.current.reverse();
        }
      }
    },
    [isActive]
  );

  return (
    <section id="featureSection" className={styles.featureSectionRoot}>
      {store.featureList.length ? (
        <BaseSwiper store={store.pageSwiperStore}>
          {store.featureList.map(({ title, img }, index) => {
            return (
              <div className={styles.slideItem} key={index}>
                <BackgroundImage src={img} alt={title} />
              </div>
            );
          })}
        </BaseSwiper>
      ) : null}
      <div data-x-ani-label="indicator" className={styles.indicator}>
        <div className={styles.btnPrev} onClick={store.goPrev} />
        <div className={styles.smallImageSwiper}>
          <BaseSwiper store={store.indicatorSwiperStore}>
            {store.featureList.map((item, index) => (
              <div className={styles.smallImage} key={index}>
                <div className="smallImageInner" style={{ backgroundImage: `url(${store.featureList[index].img})` }} />
                <div className="media-video-layer-title">
                  <div className="title-active">
                    <BackgroundImage src={store.featureList[index].tabActiveImg} />
                  </div>
                  <div className="title-default">
                    <BackgroundImage src={store.featureList[index].tabImg} />
                  </div>
                </div>
              </div>
            ))}
          </BaseSwiper>
        </div>
        <div className={styles.btnNext} onClick={store.goNext} />
      </div>
    </section>
  );
}, Store);
